import React from 'react';
import {observer} from 'mobx-react-lite';
import texts from '../../../texts';
import styles from '../../../styles.module.scss';
import {Flex, Title} from '@priority-software/priority-style-react';
import {reportGeneratorsStore} from '../../../stores/ReportGeneratorsStore';
import {SingleSeriesChartTypesOptions, MultiSeriesChartTypesOptions} from '../../../chartConsts';
import ChartTypesCard from './ChartTypesCard';
import {chartConfigInfo} from '../../../consts';
import {IChartConfig} from '../../../types';

const ChartTypePart = observer(() => {
    const {onSaveChartInfo, chartInfo, currentReport, resetChartDimensions} =
        reportGeneratorsStore?.currentScreen;

    const handleChartButtonClick = type => {
        resetChartDimensions();
        onSaveChartInfo(chartConfigInfo.type as keyof IChartConfig, type);
        currentReport.updateDirty();
    };

    const chartCategories = [
        {title: texts.singleSeriesCharts, list: Object.values(SingleSeriesChartTypesOptions)},
        {title: texts.multiSeriesCharts, list: Object.values(MultiSeriesChartTypesOptions)}
    ];

    return (
        <Flex
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            componentClasses={styles.chartTypesContainer}
        >
            <Title skin="h5" componentClasses={styles.titleWrapper}>
                {texts.chooseChartType}
            </Title>
            <Flex
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                componentClasses={styles.cardsContainer}
            >
                {chartCategories.map(({title, list}, idx) => (
                    <ChartTypesCard
                        key={idx}
                        title={title}
                        chartTypeList={list}
                        currentType={chartInfo.type}
                        handleChartButtonClick={handleChartButtonClick}
                    />
                ))}
            </Flex>
        </Flex>
    );
});

export default ChartTypePart;
